export default __webpack_public_path__ + "static/media/White_spot_virus.71f335fd.jpg";